var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1733641656173,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 11316,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M531.1488 1024h-38.2976C153.1904 1024 0 870.8096 0 531.1744v-38.2976C0 153.216 153.1904 0.0256 492.8512 0.0256h38.2976C870.8096 0.0256 1024 153.216 1024 492.8512v38.2976C1024 870.8096 870.8096 1024 531.1488 1024z",
    "p-id": 11317,
    "data-spm-anchor-id": "a313x.search_index.0.i8.62953a81BlpoHP",
    className: "selected",
    fill: "#1677FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M677.248 281.6256c-85.7088 0-133.5296 42.0864-139.648 51.1744v435.2c83.7888-51.2 279.2704-51.2 307.2-51.2V332.8c-13.4656-11.2128-55.8592-51.1744-167.552-51.1744z",
    fill: "#FFFFFF",
    opacity: 0.7,
    "p-id": 11318
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M486.4 332.8c-17.1776-15.4624-55.8592-51.2-139.648-51.2S191.2064 320.5888 179.2 332.8v384c27.9296 0 195.4816 0 307.2 51.2V332.8z",
    fill: "#FFFFFF",
    "p-id": 11319,
    "data-spm-anchor-id": "a313x.search_index.0.i9.62953a81BlpoHP",
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1d6eddccd8c7e9d5c4450e7c18a4d7ad.svg";
export { ForwardRef as ReactComponent };